/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */
export const validateExperimentName = (experimentName: string): void => {
	if (experimentName.includes(' ')) {
		throw new Error(
			`Experiment name "${experimentName}" contains spaces. ` +
				'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' +
				'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").',
		);
	}
};
